import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { ValidatorPattern } from '../utility/validators.pattern';

@Directive({
  selector: '[appDigitWithTwoDecimalNumber]',
})
export class AppDigitWithTwoDecimalNumberDirective {
  @Input() appDigitWithTwoDecimalNumber!: number;
  public regexPattern!: RegExp;

  private readonly specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    '-',
  ];

  constructor(private readonly el: ElementRef) {}

  private setRegexPattern() {
    if (this.appDigitWithTwoDecimalNumber === 7) {
      this.regexPattern = new RegExp(ValidatorPattern.SevenDigitTwoDecimal);
    } else if (this.appDigitWithTwoDecimalNumber === 9) {
      this.regexPattern = new RegExp(ValidatorPattern.NineDigitThreeDecimal);
    }
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    this.setRegexPattern();

    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);

    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const checkDotFirstPosition: string = next.substring(0, 1);
    const checkSecondPosition: string = next.substring(0, 2);

    if (
      checkDotFirstPosition === '.' ||
      (next.length > 1 &&
        checkDotFirstPosition === '0' &&
        checkSecondPosition !== '0.')
    ) {
      event.preventDefault();
    }

    if (next.length > this.appDigitWithTwoDecimalNumber) {
      if (
        next[this.appDigitWithTwoDecimalNumber] !== '.' &&
        !next.includes('.')
      ) {
        event.preventDefault();
      }
    }

    if (!this.regexPattern.exec(next)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    this.setRegexPattern();

    const pastedInput: string = event.clipboardData?.getData('text') ?? '';
    const current: string = this.el.nativeElement.value;
    const combined = current + pastedInput;

    if (!this.regexPattern.exec(combined)) {
      event.preventDefault();
    }
  }
}
